import { render } from "./bank_transactions.vue?vue&type=template&id=83f95ac2"
import script from "./bank_transactions.vue?vue&type=script&lang=js"
export * from "./bank_transactions.vue?vue&type=script&lang=js"

import "./bank_transactions.vue?vue&type=style&index=0&id=83f95ac2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__